import { createSelector } from 'reselect'
import getLoyaltyDisplayTier from './getLoyaltyDisplayTier'
import determineNextLoyaltyTier from 'loyalty/lib/determineNextLoyaltyTier'

const getLoyaltyNextTier = createSelector(
  (state: App.State) => getLoyaltyDisplayTier(state),
  (displayTier): App.LoyaltyTier | undefined => {
    return determineNextLoyaltyTier(displayTier)
  },
)

export default getLoyaltyNextTier
